<style>
  .switch-paddle {
    background: #f7f7f8;
    border-radius: 4px;
    margin: 0;
  }

  span {
    font-family: proxima-nova, sans-serif;
    color: #4c4c4b;
    font-weight: 700;
    font-size: 11px;
    line-height: 21.034px;
    text-transform: uppercase;
  }

  .switch-paddle::after {
    border-radius: 4px;
  }

  input:checked ~ .switch-paddle {
    background: #39ad48;
  }

  span.switch-active {
    color: #fff;
  }
</style>

<script>
  export let name;
  export let value;
  export let label;
</script>

<div>
  {#if label}<label>{label}</label>{/if}
  <div class="switch large">
    <input
      class="switch-input"
      id="{name}"
      type="checkbox"
      name="{name}"
      bind:checked="{value}"
    />
    <label class="switch-paddle" for="{name}">
      <span class="switch-active" aria-hidden="true">Yes</span>
      <span class="switch-inactive" aria-hidden="true">No</span>
    </label>
  </div>
</div>
